import { Box } from '../box';
import { Divider } from '../divider';
import { Flex } from '../flex';
import { Paper, type PaperProps } from '../paper';
import { Text } from '../text';
import { mergeSx } from '../utils';

export interface PaperSectionProps extends Omit<PaperProps, 'title'> {
  title: string | JSX.Element;
  endAdornment?: React.ReactNode;
}

export default function PaperSection(props: Readonly<PaperSectionProps>) {
  const { title, endAdornment, children, sx, ...restProps } = props;

  return (
    <Paper
      {...restProps}
      sx={mergeSx({ width: '100%', display: 'flex', flexDirection: 'column' }, sx)}
    >
      <Flex
        sx={{
          p: (theme) => theme.spacing(4, 6),
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {typeof title === 'string' ? <Text variant='h3'>{title}</Text> : title}
        <Box>{endAdornment}</Box>
      </Flex>
      <Divider />
      <>{children}</>
    </Paper>
  );
}
